import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { Tooltip } from 'devextreme-react/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Hypnosis } from "react-cssfx-loading";
import { notificacionSuccess, notificacionError } from '../utils/alerts';
import { db } from '../utils/db';
import { useLiveQuery } from 'dexie-react-hooks';
import './Telefonos.css';
import Dexie from 'dexie';

export default function Telefonos(props) {
    const phones = useLiveQuery(
        () => db.phones.toArray()
    );
    let input1 = useRef(null);
    let input2 = useRef(null);
    const [show, setShow] = useState(false);
    const [form, setForm] = useState({ usuario: "", telefono: "" });
    const [formAdmin, setFormAdmin] = useState({ usuario: "", telefono: "" });
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipOpenClose, setTooltipOpenClose] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(true);
    const [error2, setError2] = useState(true);
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        setShow(props.modal);
    })

    const toolTip = () => setTooltipOpen(!tooltipOpen);
    const toolTipClose = () => setTooltipOpenClose(!tooltipOpenClose);

    const onEnterKey = (event) => {
        if (event.key === 'Enter') {
            guardarTelefono();
        }
    }

    const formChange = (campo, e) => {
        setForm({ ...form, [campo]: e.value.toUpperCase().trim() });
        setError2(true);
        setError(true);
    }

    //PARA LLENAR LA FORMA DE UPDATE
    const formChangeAdmin = (campo, e) => {
        setFormAdmin({ ...formAdmin, [campo]: e.value.toUpperCase().trim() });
    }

    const cerrarModal = () => {
        setShow(false);
        props.modalClose(false);
        setError2(true);
        setError(true);
        setForm({ usuario: "", telefono: "" });
    }

    //PARA GUARADAR EL TELEFONO EN BASE DE DATOS LOCAL
    const guardarTelefono = async () => {
        setEdit(false);
        setLoading(true);
        if (form.usuario.trim() === "" && form.telefono.trim() === "") {
            setLoading(false);
            setError(false);
            setError2(false);
        }
        else if (form.usuario.trim() === "") {
            setLoading(false);
            setError(false);
        }
        else if (form.telefono.trim() === "") {
            setLoading(false);
            setError2(false);
        }
        else if (form.usuario.trim() !== "" && form.telefono.trim() !== "") {
            const id = await db.phones.add({
                user: form.usuario,
                telefono: form.telefono
            });
            setLoading(false);
            setError2(true);
            setError(true);
            notificacionSuccess(`Registro exitoso del telefono ${form.telefono} con el id ${id}`);
            setForm({ usuario: "", telefono: "" });
        } else {
            setLoading(false);
            setError2(false);
            setError(false);
            notificacionError("Favor de escribir la informacion solicitada");
        }
    }

    //PARA EDITAR EL TELEFONO
    const editar = () => {
        setEdit(true);
    }
    const editarTelefono = async (id, user, telefono) => {
        db.transaction("rw", db.phones, async () => {
            if (formAdmin.usuario && !formAdmin.telefono) {
                await db.phones.where({ id: id }).modify({ user: formAdmin.usuario, telefono: telefono });
            } else if (!formAdmin.usuario && formAdmin.telefono) {
                await db.phones.where({ id: id }).modify({ user: user, telefono: formAdmin.telefono });
            } else {
                await db.phones.where({ id: id }).modify({ user: formAdmin.usuario, telefono: formAdmin.telefono });
            }
            const phone = await db.phones.where({ id: id }).toArray();
            notificacionSuccess(`Actualización exitosa`);
            setEdit(false);
        }).catch(Dexie.ModifyError, error => {
            notificacionError(`Error ${error.failures.length} revisar`);
            setEdit(false);
        }).catch(error => {
            notificacionError(`Error ${error} revisar`);
            setEdit(false);
        });
    }
    //PARA ELIMINAR EL TELEFONO
    const borrarTelefono = async (id) => {
        db.transaction("rw", db.phones, async () => {
            await db.phones.where({ id: id }).delete();
            const phone = await db.phones.where({ id: id }).toArray();
            notificacionSuccess(`Borrado exitoso`);
        }).catch(Dexie.ModifyError, error => {
            notificacionError(`Error ${error.failures.length} revisar`);
        }).catch(error => {
            notificacionError(`Error ${error} revisar`);
        });
    }

    return (
        <div>
            <Modal isOpen={show} toggle={cerrarModal} backdrop="static" size="lg">
                <ModalHeader>Añadir numero de telefono</ModalHeader>
                {/* AÑADIR NUEVO USUARIO */}
                {loading ?
                    <Hypnosis width="100px" height="100px" style={{ margin: "0 auto", marginBottom: "1rem" }} />
                    :
                    <>
                        <ModalBody>
                            <form>
                                <Row>
                                    <Col sm={{ size: 12 }}>
                                        <label className="col-form-label fs-6 fw-bold">Nombre de Usuario</label>
                                        <input
                                            ref={input1}
                                            name='user'
                                            type="text"
                                            className="form-control"
                                            placeholder='Usuario'
                                            onChange={(e) => formChange("usuario", e.target)}
                                            value={form.usuario} />
                                        <label className="col-form-label fs-6 fw-bold text-danger" hidden={error}>Ingresar Usuario</label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={{ size: 12 }}>
                                        <label className="col-form-label fs-6 fw-bold">Telefono</label>
                                        <input
                                            ref={input2}
                                            name='phone'
                                            type="tel"
                                            className="form-control"
                                            placeholder='Telefono'
                                            onChange={(e) => formChange("telefono", e.target)}
                                            onKeyUp={onEnterKey}
                                            value={form.telefono} />
                                        <label className="col-form-label fs-6 fw-bold text-danger" hidden={error2}>Ingresar Telefono</label>
                                    </Col>
                                </Row>
                            </form>
                            <hr />
                            <Row style={{ textAlign: 'end' }}>
                                <Col>
                                    <button id="btnGuardar"
                                        className="btn btn-outline-success"
                                        onClick={guardarTelefono}
                                        onMouseEnter={toolTip}
                                        onMouseLeave={toolTip}>
                                        <FontAwesomeIcon icon="check" size="2x" />
                                        Guardar
                                    </button>
                                    <button id="btnCancelarModificacion"
                                        className="btn btn-outline-danger"
                                        onClick={cerrarModal}
                                        onMouseEnter={toolTipClose}
                                        onMouseLeave={toolTipClose}>
                                        <FontAwesomeIcon icon="times" size="2x" />
                                        &nbsp;Cancelar
                                    </button>
                                </Col>
                            </Row>
                            <hr />
                            <br />
                            {/* TABLA DE USUARIOS REGISTRADOS */}
                            <table>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Usuario</th>
                                        <th>Telefono</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {phones?.map(e => <tr>
                                        <td>{e.id}</td>
                                        <td>
                                            {edit
                                                ?
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder='Usuario'
                                                    onChange={(e) => formChangeAdmin("usuario", e.target)}
                                                    defaultValue={e.user}
                                                />
                                                :
                                                <>
                                                    {e.user}
                                                </>
                                            }
                                        </td>
                                        <td>
                                            {edit ?
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder='Telefono'
                                                    onChange={(e) => formChangeAdmin("telefono", e.target)}
                                                    defaultValue={e.telefono}
                                                />
                                                :
                                                <>
                                                    {e.telefono}
                                                </>
                                            }
                                        </td>
                                        <td style={{ width: "12em" }}>
                                            {!edit ?
                                                <button id="btnEditar"
                                                    className="btn btn-outline-info"
                                                    onClick={editar}>
                                                    <FontAwesomeIcon icon="pen" size="2x" />
                                                </button>
                                                :
                                                <button id="btnCancelar1"
                                                    className="btn btn-outline-warning"
                                                    onClick={() => editarTelefono(e.id, e.user, e.telefono)}>
                                                    <FontAwesomeIcon icon="save" size="2x" />
                                                </button>
                                            }
                                            <button id="btnEliminar"
                                                className="btn btn-outline-warning"
                                                onClick={() => borrarTelefono(e.id)}>
                                                <FontAwesomeIcon icon="trash" size="2x" />
                                            </button>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </ModalBody>
                        <ModalFooter>

                        </ModalFooter>
                    </>
                }
            </Modal>
        </div>
    )
}